var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Box, Loader } from '@pocketlaw/tetris';
import { Form, Formik } from 'formik';
import { useCompanyFeatures } from 'app/domains/companies';
import { SearchTextFieldAllowedPropertiesForTextFieldSearch, SearchTypeEnum, } from 'shared/domains/apollo/generated/types';
import { defaultColumnConfig } from './config/defaultColumnConfig';
import { getActiveColumns } from './getActiveColumns';
import { sortColumns } from './sortColumns';
import { validateOrderBy } from './validateOrderBy';
export function SearchProvider(props) {
    const { children, referrer, userColumns = [], columns, filters, modifiers, query = '', orderBy, offset = 0, limit = 20, showDirty = false, onSubmit, } = props;
    const { isFeatureAvailable, loading } = useCompanyFeatures();
    const isProjectsAvailable = isFeatureAvailable('projects');
    const columnsToSort = columns || defaultColumnConfig;
    const filteredColumns = columnsToSort.filter((col) => {
        if (col.id === 'metadataDocumentProjectIds' && !isProjectsAvailable) {
            return false;
        }
        return true;
    });
    const sortedColumns = sortColumns(filteredColumns, userColumns);
    const activeColumns = getActiveColumns(sortedColumns, userColumns);
    const initialValues = {
        referrer,
        query,
        filters,
        modifiers: Object.assign({ isFuzzy: true, searchType: SearchTypeEnum.All, searchFields: [
                {
                    field: SearchTextFieldAllowedPropertiesForTextFieldSearch.AllApplicable,
                },
            ] }, modifiers),
        columns: activeColumns,
        orderBy: validateOrderBy(orderBy),
        offset,
        limit,
    };
    const handleSubmit = (values, helpers) => __awaiter(this, void 0, void 0, function* () {
        if (onSubmit) {
            return onSubmit(values, helpers);
        }
        return values;
    });
    if (loading) {
        return (<Box width="100%" height="100%" justifyContent="center" alignItems="center">
        <Loader size={12}/>
      </Box>);
    }
    return (<Formik initialValues={initialValues} onSubmit={handleSubmit} initialStatus={{ showDirty }}>
      <Form>{children}</Form>
    </Formik>);
}
